import { useState } from "react";
import { Phone, ArrowRight, X } from "lucide-react";
import { scrollToId } from "../../lib/scroll";
import { CONTACT } from "../../lib/data";

export const FunnelTopBar = () => {
    const [barVisible, setBarVisible] = useState(true);

    return (
        <>
            <header className="fixed top-0 inset-x-0 z-50 bg-noir/80 backdrop-blur-xl border-b border-white/10" data-testid="funnel-topbar">
                <div className="mx-auto max-w-[1400px] px-4 sm:px-6">
                    <div className="flex h-[68px] items-center justify-between gap-4">
                        <button onClick={() => scrollToId("#top")} className="leading-none text-left" data-testid="funnel-logo" aria-label="WealthHaus Media — back to top">
                            <span className="block font-display font-bold text-base sm:text-lg tracking-[0.1em] text-white">
                                WEALTHHAUS <span className="text-hotpink led-text-glow">MEDIA</span>
                            </span>
                            <span className="block font-alt text-[8px] sm:text-[9px] font-semibold tracking-[0.42em] text-zinc-400 mt-0.5">
                                YOUR BRAND. EVERYWHERE.
                            </span>
                        </button>
                        <div className="flex items-center gap-3">
                            <a href={CONTACT.phoneHref} className="hidden sm:flex items-center gap-2 font-alt text-xs font-semibold tracking-wider text-zinc-300 hover:text-white transition-colors" data-testid="topbar-phone">
                                <Phone size={14} className="text-hotpink" /> {CONTACT.phone}
                            </a>
                            <button onClick={() => scrollToId("#quote")} className="btn-glossy-pink !py-2.5 !px-5 !text-[11px]" data-testid="topbar-quote-button">
                                GET A QUOTE <ArrowRight size={14} />
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {barVisible && (
                <div className="fixed bottom-0 inset-x-0 z-50 lg:hidden" data-testid="mobile-quote-bar">
                    <div className="mx-3 mb-3 flex items-center gap-2 rounded-2xl border border-white/15 bg-noir/90 backdrop-blur-xl p-2.5 shadow-[0_10px_40px_rgba(0,0,0,0.7)]">
                        <a href={CONTACT.phoneHref} className="btn-chrome !px-4 !py-3 !text-[11px] shrink-0" data-testid="mobile-bar-call" aria-label={`Call ${CONTACT.phone}`}>
                            <Phone size={15} />
                        </a>
                        <button onClick={() => scrollToId("#quote")} className="btn-glossy-pink flex-1 !py-3 !text-[11px]" data-testid="mobile-bar-quote">
                            GET A QUOTE <ArrowRight size={14} />
                        </button>
                        <button onClick={() => setBarVisible(false)} className="p-2 text-zinc-500 hover:text-white" aria-label="Dismiss" data-testid="mobile-bar-close">
                            <X size={16} />
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};
